export const routeFromLocation = () => globalThis.location?.pathname || "/";

export const claimTokenFromLocation = () => {
  const match = routeFromLocation().match(/^\/claim\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const teamInviteTokenFromLocation = () => {
  const match = routeFromLocation().match(/^\/team-invite\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const teamJoinIdFromLocation = () => {
  const match = routeFromLocation().match(/^\/team-join\/([0-9a-f-]+)/i);
  return match ? match[1] : null;
};

export const teamRegistrationIdFromLocation = () => {
  const match = routeFromLocation().match(/^\/register-team\/([0-9a-f-]+)/i);
  return match ? match[1] : null;
};

export const tournamentIdFromLocation = () => {
  const match = routeFromLocation().match(/^\/tournaments\/([0-9a-f-]+)/i);
  return match ? match[1] : null;
};
